import api from "Utils/api";

export class CompaniesHouseApi {
    public static getCompanyAvailabilityApi = (companyName: string) => api.get(`company-formations/companyAvailability?companyName=${encodeURIComponent(companyName)}`);
}
